import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'
import { OntologyFeature } from './ontologyFeatureTypings'
import { USE_ONTOLOGY_FEATURE_BY_ID_KEY } from './useGetOntologyFeatureById'

type EditOntologyFeaturePayload = Omit<OntologyFeature, 'instances' | 'featureId' | 'programId'>

export function useEditOntologyFeature(programId?: string, featureId?: string, onSuccess?: () => void) {
  const queryClient = useQueryClient()

  return useMutation<unknown, ErrorResponse, EditOntologyFeaturePayload>({
    mutationFn: async (values: EditOntologyFeaturePayload) => {
      const { data } = await apiClient.put(`/int/v3/programs/${programId}/ontology/${featureId}`, values)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
      queryClient.invalidateQueries({ queryKey: [USE_ONTOLOGY_FEATURE_BY_ID_KEY] })

      onSuccess?.()
    },
  })
}
